import { createPluginsStore } from './stores/plugins';

export const plugins = createPluginsStore();
